import { FC } from 'react';
import { styled } from '@material-ui/styles';
import EngineIcon from '../component/primitive/Icons/EngineIcon';
import { PageTitle, SectionTitle } from '../component/primitive/TypographyUI';
import { SPACING_MEDIUM } from '../constant/spacing';

const BasicTopPage: FC = () => {
  return (
    <Root>
      <TitleFlex>
        <PageTitle variant="h2">Kaizen Platfrom Cloud Engine</PageTitle>
        <IconWrap>
          <EngineIcon freeSize />
        </IconWrap>
      </TitleFlex>
      <Container>
        <SectionTitle variant="h3">{`What's new`}</SectionTitle>
      </Container>
    </Root>
  );
};

const Root = styled('div')({
  padding: '0 24px',
});

const TitleFlex = styled('div')({
  display: 'flex',
  justifyContent: 'flex-start',
});

const Container = styled('div')({
  padding: SPACING_MEDIUM,
  backgroundColor: 'rgba(255, 255, 255, 1)',
  boxShadow: '0px 1px 9px rgba(0, 0, 0, 0.04)',
  borderRadius: '8px',
});

const IconWrap = styled('div')({
  margin: 'auto 12px',
  flex: '32px 0 0',
});

export default BasicTopPage;
